import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'common/components/elements/buttons/primary';
import NumberFormatter from 'admin/utils/NumberFormatter';
import { useSelector } from 'react-redux';
import {
   MediaButton,
   MediaMemberBottonOptions,
} from 'common/components/modules/media';

const BottomContent = ({
   hasAccess,
   isLiked,
   commentsCount,
   onClickComment,
   onClickShare,
   onClickLike,
   position,
   onDeleteStory,
   isAdmin,
   isAuthUsers,
   isMultiple,
   onDeleteImage,
   openFullScreenCard,
   onClickTip,
   id,
   onTipOpen,
   onClickOpenTips,
   onClickSetId,
   totalTip,
   onShare,
   isShowPage,
   siteInfo,
   onEditStory,
   pinStory,
   isPinned,
   isDemoMode,
   showComments = false,
}) => {
   const numberFormatter = new NumberFormatter();
   const [optionStory, setOptionStory] = useState(false);
   function openOptionModal(value) {
      setOptionStory(value)
   }
   const screenWidth = useSelector(state => state.common.screenWidth)

   const onClick = (e) => {
      e.stopPropagation()
      if(!isAdmin) {
         !!onTipOpen && !isShowPage && onTipOpen()
         onClickTip(true, {
            "resource_id": id,
            "resource_type": 'story',
         });
      }
      if(isAdmin) {
         // console.log('total tip from bottom', totalTip);
         onClickOpenTips()
         onClickSetId(id)
      }
   }
   const canSendTip = siteInfo?.tip && !isAdmin;
   const canShare = !isAdmin && !!onShare && siteInfo?.share;
   const canLike = siteInfo?.like && !!onClickLike;
   return (
      <div
         role='presentation'
         onClick={ (e) => e.stopPropagation() }
         className={ cx({
            [`flex z-10 w-full justify-between ${ position } px-2 pb-2`]: true,
            'bottom-0 left-0': position === 'absolute',
            'backdrop-stitch': position !== 'absolute',
         }) }
      >
         {
            hasAccess && showComments && (
               <MediaButton
                  iconName='comment'
                  onClick={ (e) => {
                     e.stopPropagation();
                     e.preventDefault();
                     onClickComment();
                  } }
                  text={ `${ siteInfo?.total_comment_counts ? (!!commentsCount ? commentsCount === 1 ? commentsCount + ' comment' : numberFormatter.withCommas(commentsCount) + ' comments' : '') : '' }` }
               />
            )
         }
         <div className='flex gap-2'>

            {
               hasAccess  && !isAdmin && (
                  <MediaMemberBottonOptions
                     isLiked={ isLiked }
                     id={ id }
                     onClickLike={ onClickLike }
                     canLike={ canLike }
                     canShare={ canShare }
                     canSendTip={ canSendTip }
                     canChangeFavorite={ false }
                     onShare={ _ => onShare(id, 'story') }
                     onClickTip={ onClick }
                     collectionType='story'

                  />
               )
            }
            {
               isAdmin && (
                  <MediaButton
                     iconName='options-vertical'
                     onClick={ (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        openOptionModal(true)
                     } }
                  />
               )
            }
            {
               (!!openFullScreenCard && screenWidth > 700) &&
               <MediaButton
                  iconName='full-screen'
                  onClick={ (e) => {
                     e.stopPropagation();
                     e.preventDefault();
                     openFullScreenCard(e)
                  } }
               />

            }
         </div>
         {
            optionStory && (
               <div
                  role='presentation'
                  onClick={ () => openOptionModal(false) }
                  className='absolute h-full w-full bottom-0 flex items-end left-0'
                  style={ { backgroundColor: 'rgba(248, 249, 250, 0.6)' } }
               >
                  <div className='rounded-t-lg flex flex-col items-center bg-panel dark:bg-panel-dark w-full'>
                     <div className='flex w-full h-12 items-center border-b dark:border-divider-dark border-divider justify-between px-4'>
                        <span className='text-major dark:text-major-dark text-base'>Options:</span>
                        <div>
                           <Button
                              iconName='close'
                              onClick={ () => openOptionModal(false)  }
                              backgroundColor='transparent'
                              fontIconColor='secondary'
                              padding='none'
                              alignment='end'
                           />
                        </div>
                     </div>
                     {
                        isMultiple && (
                           <div className='flex w-full h-12 items-center border-b dark:border-divider-dark border-divider justify-between px-4'>
                              <Button
                                 text='Remove photo from this story'
                                 onClick={ () => onDeleteImage() }
                                 iconName='close'
                                 fontIconSize='extraLarge'
                                 iconPosition='left'
                                 backgroundColor='transparent'
                                 fontIconColor='major'
                                 darkIconcolor='major-dark'
                                 textColor='major dark:text-major-dark'
                                 padding='none'
                                 alignment='end'
                                 disabled={ isDemoMode }
                                 dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
                              />
                           </div>
                        )
                     }
                     {
                        !!onEditStory &&
                           <div className='flex w-full h-12 items-center justify-between px-4'>
                              <Button
                                 text='Edit story'
                                 onClick={ () => onEditStory() }
                                 iconName='pencil'
                                 fontIconSize='extraLarge'
                                 iconPosition='left'
                                 backgroundColor='transparent'
                                 fontIconColor='major'
                                 darkIconColor='major-dark'
                                 textColor='major dark:text-major-dark'
                                 padding='none'
                                 alignment='end'
                                 disabled={ isDemoMode }
                                 dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
                              />
                           </div>
                     }
                     {
                        !!onShare && <div className='flex w-full h-12 items-center **border-b dark:border-divider-dark border-divider justify-between px-4'>
                           <Button
                              text='Share'
                              onClick={ () => onShare(id, 'story') }
                              iconName='share'
                              fontIconSize='extraLarge'
                              iconPosition='left'
                              backgroundColor='transparent'
                              fontIconColor='major'
                              darkIconcolor='major-dark'
                              textColor='major dark:text-major-dark'
                              padding='none'
                              alignment='end'
                           />
                        </div>
                     }
                     {
                        !!pinStory &&
                           <div className='flex w-full h-12 items-center justify-between px-4'>
                              <Button
                                 text={ !isPinned ? 'Pin story' : 'Unpin story' }
                                 onClick={ pinStory }
                                 iconName={ !isPinned ? 'pin' : 'unpin' }
                                 fontIconSize='extraLarge'
                                 iconPosition='left'
                                 backgroundColor='transparent'
                                 fontIconColor='major'
                                 darkIconColor='major-dark'
                                 textColor='major dark:text-major-dark'
                                 padding='none'
                                 alignment='end'
                              />
                           </div>
                     }
                     <div className='flex w-full h-12 items-center justify-between px-4'>
                        <Button
                           text='Delete this story'
                           onClick={ () => onDeleteStory() }
                           iconName='delete'
                           fontIconSize='extraLarge'
                           iconPosition='left'
                           backgroundColor='transparent'
                           fontIconColor='error'
                           darkIconColor='error-dark'
                           textColor='error dark:text-error-dark'
                           padding='none'
                           alignment='end'
                           disabled={ isDemoMode }
                           dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
                        />
                     </div>

                  </div>
               </div>
            )
         }
      </div>
   );
};

BottomContent.defaultProps = {
   positions: 'relative',
   onClickComment: () => {},
};

BottomContent.propTypes = {
   hasAccess: PropTypes.bool,
   isLiked: PropTypes.bool,
   commentsCount: PropTypes.number,
   onClickComment: PropTypes.func.isRequired,
   onClickShare: PropTypes.func,
   onClickLike: PropTypes.func,
   onDeleteStory: PropTypes.func,
   isAdmin: PropTypes.bool,
   isAuthUsers: PropTypes.bool,
   isMultiple: PropTypes.bool,
   onDeleteImage: PropTypes.func,
   position: PropTypes.oneOf([
      'absolute', 'fixed', 'relative',
   ]),
   openFullScreenCard: PropTypes.func,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   onTipOpen: PropTypes.func,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   totalTip: PropTypes.number,
   onShare: PropTypes.func,
   isShowPage: PropTypes.bool,
   siteInfo: PropTypes.object,
   onEditStory: PropTypes.func,
   pinStory: PropTypes.func,
   isPinned: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   showComments: PropTypes.bool,
};

export default memo(BottomContent);
